import { getLocale, locales } from '@/ui/i18n/i18n';

const contactUrls: Partial<Record<locales, string>> = {
  en: '/contact',
  de: '/de/kontakt',
  es: '/es/contacto',
  fr: '/fr/contacter',
  'pt-BR': '/pt-br/contato',
};

export function getWebsiteContactUrl(): string {
  return process.env.VUE_APP_WEBSITE_URL + (contactUrls[getLocale()] || contactUrls.en!);
}
